var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImagePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 118",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E9F1EA",
    d: "M0 0h200v118H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E6052",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M115.625 41.813h-31.25a4.688 4.688 0 0 0-4.688 4.687v25a4.688 4.688 0 0 0 4.688 4.688h31.25a4.687 4.687 0 0 0 4.687-4.688v-25a4.687 4.687 0 0 0-4.687-4.688Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E6052",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M107.812 54.313a3.126 3.126 0 1 0 0-6.252 3.126 3.126 0 0 0 0 6.252Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E6052",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "m104.688 66.791-8.854-8.837a3.125 3.125 0 0 0-4.284-.127L79.688 68.374m17.187 7.813 12.045-12.045a3.125 3.125 0 0 1 4.21-.196l7.182 5.99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlaceholder);
export default __webpack_public_path__ + "static/media/image-placeholder.648ffc89540c0af9aa927c7695766d76.svg";
export { ForwardRef as ReactComponent };